import { Injectable } from '@angular/core';

const CIPHER: number[] = [0,7,6,2,9,4,1,5,3,8];

@Injectable({
  providedIn: 'root',
})
export class DotIdObfuscationService {
  private encodeDotIdsMap: Map<number, number> = new Map();
  private decodeDotIdsMap: Map<number, number> = new Map();

  public encodeDotId(dotId: number | string): number | undefined {
    if (!dotId) return undefined;

    dotId = Number(dotId);
    if (this.encodeDotIdsMap.has(dotId)) {
      return this.encodeDotIdsMap.get(dotId);
    }
    const obfuscatedDotId: number = this.encoder(dotId);
    this.encodeDotIdsMap.set(dotId, obfuscatedDotId);
    this.decodeDotIdsMap.set(obfuscatedDotId, dotId);
    return obfuscatedDotId;
  }

  public decodeDotId(dotId: number | string): number | undefined {
    if (!dotId) return undefined;

    dotId = Number(dotId);
    if (this.decodeDotIdsMap.has(dotId)) {
      return this.decodeDotIdsMap.get(dotId);
    }
    return dotId;
  }

  private encoder(dotId: number): number {
    const obfuscatedDotId: number[] = dotId.toString().split('').map(Number);
    obfuscatedDotId.forEach((digit: number, index: number) => {
      obfuscatedDotId[index] = CIPHER[digit];
    });
    return Number(obfuscatedDotId.join(''));
  }
}
